import * as ActionTypes from "./actionTypes"
import {changeTeamAssignmentsWithId, GET_EDIT_USER_DATA_METHOD, loadEditUserPanelDataWithId} from "../editPanel/actions"
import {getCopyUserFrom, getPanelUser, getUserId} from "./selectors"
import {createActionObject} from '../../../redux/utils'
import {getEditUserId} from '../editPanel/selectors'
import rpcCall, {abortCall} from '../../../util/rpc/rpcCalls'
import {updateFeatures} from '../../../features/actions'
import {addTimeZoneGroups, addUserGroups, removeUser} from '../../../entities/actions'
import messageResource from '../../../messageResource'
import {toast} from '../../../toasts/actions'
import {createAction} from 'redux-actions'
import {Exceptions} from './constants'
import {batched} from '../../../redux/batch'
import {UserTeamAssignmentType} from '../constants'
import * as SyncCallbacks from '../editPanel/syncCallbacks'
import {closeAllPanels, handleCommonError} from '../../../administration/userManagement/common/actions'
import {formatFmlWithCheck} from '../../../util/UserNameFormat'

export const openTeamAssignmentsPanel = (userId) => dispatch => {
    dispatch(createActionObject(ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET, userId))
}

export const openTeamAssignmentsPanelFromEditPanel = () => (dispatch, getState) => {
    dispatch(openTeamAssignmentsPanel(getEditUserId(getState())))
}

export const closeTeamAssignmentsPanel = () => (dispatch) => {
    abortCall(GET_EDIT_USER_DATA_METHOD)
    dispatch(createActionObject(ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET, null))
}

export const loadTeamAssignmentsData = () => (dispatch, getState) => {
    dispatch(loadEditUserPanelDataWithId(getUserId(getState())))
}

export const changeTeamAssignmentsData = ({teamAssignmentType, assignedGroupIds, assignedUserIds}) => (dispatch, getState) => {
    if (teamAssignmentType !== UserTeamAssignmentType.SELECTED)
        dispatch(closeCopyContent())

    dispatch(changeTeamAssignmentsWithId(getUserId(getState()), {teamAssignmentType, assignedGroupIds, assignedUserIds}))
}

const openCopyContent = createAction(ActionTypes.COPY_CONTENT_OPEN)

const closeCopyContent = createAction(ActionTypes.COPY_CONTENT_CLOSE)

export const setCopyUserId = createAction(ActionTypes.COPY_USER_ID_SET)

export const setCopyLoading = createAction(ActionTypes.COPY_LOADING_SET)

export const setCopySelectorUsers = createAction(ActionTypes.COPY_USERS_FOR_SELECTOR_SET)

export const setUserFromAssignedUsers = createAction(ActionTypes.USER_FROM_ASSIGNED_USERS_SET)

export const showCopyContent = () => (dispatch) => {
    dispatch(openCopyContent())
    dispatch(loadCopyTeamAssignmentSelectorUsers())
}

export const cancelCopy = () => (dispatch) => {
    dispatch(closeCopyContent())
}

const loadCopyTeamAssignmentSelectorUsers = () => (dispatch) => {
    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.getUserSelectorData', [])
        .then(batched((data) => {
            dispatch(setCopyLoading(false))
            dispatch(updateFeatures(
                {
                    UGR: data.ugrEnabled,
                    TZG: data.tzgEnabled,
                }
            ))
            dispatch(addTimeZoneGroups(data.timeZoneGroups))
            dispatch(addUserGroups(data.userGroups))
            dispatch(setCopySelectorUsers(data.users))
        }))
        .catch((err) => {
            dispatch(setCopyLoading(false))
        })
}

export const loadUserFromAssignedUsers = (userId) => (dispatch) => {
    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.getAssignedUsers', [userId],
        (rpcError) => rpcError.handleOnExceptions([
            Exceptions.NoSuchUserException,
            Exceptions.NoRightsToManageAccountSettings,
        ]))
        .then(batched(data => {
            dispatch(setUserFromAssignedUsers(data))
            dispatch(setCopyUserId(userId))
            dispatch(setCopyLoading(false))
        }))
        .catch((error) => {
            dispatch(setCopyLoading(false))
            switch (error.getException()) {
                case Exceptions.NoSuchUserException:
                    alert(messageResource.getMessage('work_assignments.panel.copy.error.user_deleted'))
                    dispatch(removeUser(userId))
                    SyncCallbacks.onNoSuchUserException(userId)
                    break
                case Exceptions.NoRightsToManageAccountSettings:
                    alert(messageResource.getMessage('userlist.js.error_manage_account_settings_right_revoked'))
                    window.location.reload()
                    break
                default:
                    console.error(error)
            }
        })
}

export const copyAssignments = () => (dispatch, getState) => {
    const state = getState()
    const userTo = getPanelUser(state)
    const userFrom = getCopyUserFrom(state)

    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.copyTeamAssignmentsFrom', [userTo.id, userFrom.id],
        (rpcError) => rpcError.handleOnExceptions([
            Exceptions.NoSuchUserException,
            Exceptions.NoSuchCopyUserException,
            Exceptions.NoRightsToManageAccountSettings,
        ]))
        .then(batched(() => {
            dispatch(setCopyLoading(false))
            dispatch(closeCopyContent())
            dispatch(loadTeamAssignmentsData())
            dispatch(toast(messageResource.getMessage('user.panel.permissions.team_assignments.copy.toast.settings_copied', [userTo.firstName, formatFmlWithCheck(userFrom)])))
        }))
        .catch((error) => {
            dispatch(setCopyLoading(false))
            dispatch(handleCommonError(userTo.id, error))
            switch (error.getException()) {
                case Exceptions.NoSuchUserException:
                    dispatch(closeAllPanels())
                    break
                case Exceptions.NoSuchCopyUserException:
                    alert(messageResource.getMessage('work_assignments.panel.copy.error.user_deleted'))
                    dispatch(removeUser(userFrom.id))
                    SyncCallbacks.onNoSuchUserException(userFrom.id)
                    break
                default:
                    console.error(error)
                    dispatch(closeCopyContent())
            }
        })
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/actions.js